export default function IconLeftArrow({ width = 13, height = 13 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="icon/left">
                <path
                    id="Vector (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35355 3.31075C8.15829 3.11549 7.84171 3.11549 7.64645 3.31075L4.64645 6.31075C4.45118 6.50602 4.45118 6.8226 4.64645 7.01786L7.64645 10.0179C7.84171 10.2131 8.15829 10.2131 8.35355 10.0179C8.54882 9.8226 8.54882 9.50602 8.35355 9.31075L5.70711 6.66431L8.35355 4.01786C8.54882 3.8226 8.54882 3.50602 8.35355 3.31075Z"
                    fill="#999999"
                />
            </g>
        </svg>
    );
}

